/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileTimestamp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18 10a4 4 0 0 1 4 4c0 .604-.21 1.618-1 2.441V18h2v5H13v-5h2v-1.559c-.79-.823-1-1.837-1-2.441a4 4 0 0 1 4-4zm-3 11h6v-1h-6zm3-9a2 2 0 0 0-2 2c0 .27.125.83.614 1.21l.386.302V18h2v-2.488l.386-.301A1.62 1.62 0 0 0 20 14a2 2 0 0 0-2-2z" />
        <path d="M20 7.586V9h-7V4H6v16h5v2H4V2h10.414zM15 7h1.586L15 5.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileTimestamp as FileTimestamp };
